var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"main-content-display"},[_c('div',{staticClass:"middle_part flex-grow-1"},[_c('div',{staticClass:"mots_cles"},[_c('span',[_vm._v(_vm._s(_vm.$t('sav.pageTitle')))])]),_c('simulate-code-use'),_c('open-locker')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }